import { useState } from "react";
import {
  FaHeartbeat,
  FaStethoscope,
  FaCalendarAlt,
  FaUserMd,
} from "react-icons/fa";
import { motion } from "framer-motion";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";

const ScreenOne = () => {
  const navigate = useNavigate();
  const [showInfo, setShowInfo] = useState(false);

  const props = {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0 },
  };

  return (
    <div id="home" className="min-h-screen relative md:pt-24 overflow-x-hidden">
      <section className="relative flex flex-col md:flex-row items-center justify-between px-6 md:px-10 pt-26 md:py-14">
        <div className="text-center md:text-left md:w-1/2 z-10">
          <motion.h1
            {...props}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
            className="text-4xl md:text-5xl font-extrabold text-pink-700 leading-tight animate-slideInLeft"
          >
            PCOD Care & Women's Health
          </motion.h1>
          <motion.p
            {...props}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.7 }}
            className="mt-4 text-lg md:text-xl text-gray-700 animate-slideInLeft animation-delay-300"
          >
            Personalized treatment, lifestyle guidance, and compassionate
            support for PCOD management.
          </motion.p>
          <motion.p
            {...props}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.9 }}
            className="mt-6 text-base md:text-lg text-gray-600 leading-relaxed animate-fadeIn animation-delay-500"
          >
            At <span className="font-semibold text-pink-600">Glow PCOD</span>,
            we understand the unique challenges faced by women with PCOD. Our
            approach focuses not just on treatment, but on helping you regain
            confidence and long-term well-being.
          </motion.p>
          <motion.div
            {...props}
            transition={{ duration: 0.8, ease: "easeOut", delay: 1.8 }}
            className="mt-6"
          >
            <Button
              onClick={() => navigate("/appointment")}
              label="Book an Appointment"
            />
          </motion.div>
        </div>

        <div className="relative md:w-1/2 mt-10 md:mt-0 flex justify-center md:justify-end">
          <motion.img
            {...props}
            transition={{ duration: 0.8, ease: "easeOut", delay: 1.1 }}
            src="pcod.jpg"
            alt="PCOD health"
            className="w-72 h-72 md:w-[28rem] md:h-[28rem] object-cover"
          />

          <motion.div
            className="absolute -top-4 -right-4 p-4 rounded-full shadow-xl shadow-gray-900 backdrop-blur-md cursor-pointer"
            onMouseEnter={() => setShowInfo(true)}
            onMouseLeave={() => setShowInfo(false)}
            {...props}
            transition={{ duration: 0.8, ease: "easeOut", delay: 2.2 }}
          >
            <FaHeartbeat className="text-3xl text-pink-600" />

            <div
              className={`absolute top-0 right-16 bg-white/60 text-gray-800 text-sm rounded-lg shadow-lg px-4 py-3 w-56 backdrop-blur-md transform transition-all duration-500 ${
                showInfo
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 translate-x-4"
              }`}
            >
              <p className="font-bold flex items-center gap-2">
                <FaUserMd className="text-[#020046]" /> Dr. Priya Sharma
              </p>
              <p className="text-gray-600 flex items-center gap-2 mt-1">
                <FaStethoscope className="text-[#020046]" /> Gynecologist
              </p>
              <p className="text-gray-600 flex items-center gap-2 mt-1">
                <FaCalendarAlt className="text-[#020046]" /> PCOD Specialist
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ScreenOne;
